import { render, staticRenderFns } from "./EditOrganizationQuestionExclusions.vue?vue&type=template&id=d962e23a"
import script from "./EditOrganizationQuestionExclusions.vue?vue&type=script&lang=js"
export * from "./EditOrganizationQuestionExclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports